import * as pdfjsLib from "pdfjs-dist";

pdfjsLib.GlobalWorkerOptions.workerSrc = `https://unpkg.com/pdfjs-dist@${pdfjsLib.version}/build/pdf.worker.min.mjs`;

// Render every page of a PDF (Uint8Array/ArrayBuffer) to PNG data URLs.
// onProgress(done, total) is called after each page so the UI can report status.
export async function renderPdfPages(data, { scale = 1.6, onProgress, only } = {}) {
    const doc = await pdfjsLib.getDocument({ data }).promise;
    const out = [];
    for (let p = 1; p <= doc.numPages; p++) {
        if (only && !only.includes(p)) continue;
        const page = await doc.getPage(p);
        const viewport = page.getViewport({ scale });
        const canvas = document.createElement("canvas");
        canvas.width = viewport.width;
        canvas.height = viewport.height;
        const ctx = canvas.getContext("2d");
        await page.render({ canvasContext: ctx, viewport }).promise;
        out.push({ page: p, dataUrl: canvas.toDataURL("image/png"), w: viewport.width, h: viewport.height });
        if (onProgress) onProgress(p, doc.numPages);
    }
    return out;
}
